import { useSelector } from 'react-redux';
import {all_information, GetErpTypeFromConfig, loadingShow} from '../App';
import {
  addAssignmentToCapacityElement,
  addCapacityNote,
  deleteCapacityElement,
  deleteCapacityIDlement,
} from '../services/Capacity/CapacityServices';
import {
  EditWorkOrder,
  GetPlanOrderGant,
} from '../services/CloudScheduler/CloudSchedulerServices';
import {
  Addsource_request,
  Deletesource_request,
  getsource_request,
} from '../services/Dig/RequestSourceService/RequestSourceService';
import {
  getGlobalFilter,
  getSystemConfig,
} from '../services/GlobalFilter/GlobalFilterServices';
import { EditGantt } from '../services/Operations/OperationServices';
import Message from './Message/Message';
import { GetCloudExecutionDatasByPlan } from '../services/CloudExecutionServices/CloudExecutionService';
import {getLocalUtcOffSetValue} from "./Methods/methods";

export const SendRequest = (
  request_sql: string,
  request_result: string,
  calback?: (args: any) => void,
  noNeedWatch?: boolean
) => {
  const obj = {
    request_sql: request_sql,
    request_result: request_result,
    organization_id: all_information.company_id?.toString(),
    app: all_information.app,
  };
  Addsource_request(obj)
    .then((el) => {
      if (!noNeedWatch) {
        var data = el.data;
        watch(data.request_id, calback);
      }
    })
    .catch((error) => {
      if (error.response) {
        Message.error(error.response.data);
        Message.error(error.response.status);
        Message.error(error.response.headers);
      } else if (error.request) {
        Message.error(error.request);
      } else {
        Message.error('Error: ' + error.message);
      }
      Message.error(error.config);
    });
};
const watch = (request_id: any, calback?: (args: any) => void) => {
  var theTimeOut = setTimeout(() => {
    Message.error('Timeout. Windows Service did not responde.');
    loadingShow(false, 'Checking');
    clearInterval(interval);
    Deletesource_request({
      request_id: request_id,
    });
  }, 6000);
  var interval = setInterval(() => {
    getsource_request(request_id)
      .then((el) => {
        var getData = el.data[0];
        if (getData.request_result !== '') {
          clearInterval(interval);
          clearTimeout(theTimeOut);
          loadingShow(false);
          if (calback) calback({ result: 'success' });
          Message.success('Executed...');
          Deletesource_request({
            request_id: request_id,
          });
        }
      })
      .catch(() => {});
  }, 500);
};

export const AddCapacityRequest = async (theObj: any, calback: () => void) => {
  return await addAssignmentToCapacityElement(theObj)
    .then((result) => {
      Message.success('Added successfully...');
      calback();
    })
    .catch((err) => {
      Message.error('Add failed!!!');
    });
};
export const DeleteCapacityRequest = async (
  theObj: any,
  calback: () => void
) => {
  return await deleteCapacityElement(theObj)
    .then((data) => {
      Message.success('Delete is success');

      calback();
    })
    .catch((e) => {
      Message.error('Error occured while record being deleting');
    });
};
export const EditMassOrder = async (
  theObj: any,
  calback: () => void,
  gmt: number,
  allowAutoCommit: boolean
) => {
    const safeGmt = typeof gmt === 'number' && !isNaN(gmt) ? gmt : 0;
    const serverOffsetMillis = 60 * 1000 * safeGmt * (-60);

    const localOffset = new Date().getTimezoneOffset();
    const localOffsetMillis = 60 * 1000 * localOffset;

    const differenceOffsetMillis = serverOffsetMillis - localOffsetMillis;


  theObj.map((item: any) => {

    if(item.scheduled_start_date){
      item.scheduled_start_date = new Date(
          new Date(item.scheduled_start_date)?.getTime() + differenceOffsetMillis
      ).toString();
      item.scheduled_end_date = new Date(
          new Date(item.scheduled_end_date)?.getTime() + differenceOffsetMillis
      ).toString();
    }
    });

  let timezoneOffset= safeGmt * -60;
  return await EditWorkOrder(theObj, timezoneOffset, allowAutoCommit)
    .then((data) => {
      Message.success('Edit is success');
      loadingShow(false);
      calback();
    })
    .catch((e) => {
      Message.error('Error occured while record being editing');
    });
};
export const DeleteCapacityWithIDRequest = (
  theObj: any,
  calback?: () => void
) => {
  deleteCapacityIDlement(theObj)
    .then((data) => {
      Message.success('Delete is success');
      loadingShow(false);
      calback && calback();
    })
    .catch((e) => {
      Message.error('Error occured while record being deleting');
    });
};
export const CreateNoteCapacity = (
  theObj: any,
  calback?: (data: any) => void
) => {
  addCapacityNote(theObj)
    .then((data) => {
      Message.success('Creation is success');
      loadingShow(false);
      calback && calback(data.data);
    })
    .catch((e) => {
      Message.error('Error occured while record being created');
    });
};
export const SavePointOfTheGantt = async (
  batch_obj: Array<any>,
  callBack: () => void
) => {
  if (batch_obj.length === 0) {
    // Message.info('There is nothing to change !!!');
    // return;
  }
  loadingShow(true, 'Saving...');
  await EditGantt(batch_obj)
    .then(() => {
      $('#cloudSchedulerSavePoint').removeAttr('disabled');
      loadingShow(false);
      Message.success('Success');
      batch_obj = [];
      callBack();
    })
    .catch(() => {
      $('#cloudSchedulerSavePoint').removeAttr('disabled');
      loadingShow(false);
    });
};
export const GetGlobalFilter = async (cond: any) => {
  let theData: Array<any> = [];
  await getGlobalFilter(cond)
    .then((res) => {
      theData = res.data;
    })
    .catch(() => {
      console.log('Error when get data');
    });
  return theData;
};
export const GetSystemConfig = async (cond: any) => {
  let theData: Array<any> = [];
  await getSystemConfig(cond)
    .then((res) => {
      theData = res.data;
    })
    .catch((err) => {
      console.log('Error when get data');
    });
  return theData;
};
export const GetGanttDataByPlan = async (cond: any) => {
  let theData: Array<any> = [];
  await GetPlanOrderGant(cond)
    .then((result) => {
      theData = result.data;
    })
    .catch((er) => {
      console.log('Something went wrong');
      if (er.response) {
        Message.error(
          er.response.data +
            '\n' +
            er.response.status +
            '\n' +
            er.response.headers
        );
      } else if (er.request) {
        Message.error(er.request);
      } else {
        Message.error('Error: ' + er.message);
      }
      Message.error(er.config);
      loadingShow(false);
    });
  return theData;
};

export const GetCloudExecutionOperationDatasByPlan = async (id: number, isBreakIn : boolean) => {
  let theData: Array<any> = [];
  await GetCloudExecutionDatasByPlan(id, isBreakIn)
    .then((result) => {
      theData = result.data;
    })
    .catch((er) => {
      console.log('Something went wrong');
      if (er.response) {
        Message.error(
          er.response.data +
            '\n' +
            er.response.status +
            '\n' +
            er.response.headers
        );
      } else if (er.request) {
        Message.error(er.request);
      } else {
        Message.error('Error: ' + er.message);
      }
      Message.error(er.config);
      loadingShow(false);
    });
  return theData;
};

